export const contactEmail = 'samson.a@smarthealth.net';
